export default "__VITE_ASSET__BQiOnkUd__"